export default __webpack_public_path__ + "static/media/blog5.36af1cfe.jpg";